export default () => ({
  entity: 'term',
  entities: 'terms',
  currentEntity: {},
  terms: [],
  errors: {
  }
})



// WEBPACK FOOTER //
// ./src/app/professional/terms/index/resources/data.js